// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","container":"_3HOZ","close":"_2EZ_","question":"_3ThP","questionTitle":"_3XjL","option":"_10sT","label":"_2Ovv","recs":"_1fix"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Quiz/Quiz.scss
// module id = omfT
// module chunks = 0